<div class="mb-2">
  <select multiple="multiple" class="form-select border" [(ngModel)]="selectedKeys" [ngStyle]="selectStyleStyle"
    [attr.data-cy]="dataLabel" [attr.aria-label]="dataLabel">
    @for (option of options.items; track option) {
      <option [ngValue]="options.rowKeyFn(option)"
        (mousedown)="handleMouseDown($event, option)" (mousemove)="$event.preventDefault()"
        [attr.data-cy]="options.rowKeyFn(option)" [class.d-none]="isSelected(option)">
        {{ options.rowLabelFn(option) }}
      </option>
    }
  </select>
  @for (k of selectedKeys; track k) {
    <rl-chip (onRemove)="removeChip(k)">
      {{toChipLabel(k)}}
    </rl-chip>
  }
</div>